import { render, staticRenderFns } from "./numberInput.vue?vue&type=template&id=0bf13078&scoped=true&"
import script from "./numberInput.vue?vue&type=script&lang=ts&"
export * from "./numberInput.vue?vue&type=script&lang=ts&"
import style0 from "./numberInput.vue?vue&type=style&index=0&id=0bf13078&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf13078",
  null
  
)

export default component.exports